import { makeStyles } from "tss-react/mui";
import { palette, radius, shadow } from "@/themes/tokens";

// Rounded frame, white round arrows and rounded thumbnails, as in the mobile carousel.
export const useImageCarouselStyles = makeStyles()((theme) => ({
    // No frame: the photos fill the width of the column.
    image: {
        border: '0 !important',
        boxShadow: 'none !important',
        background: 'transparent !important',
        borderRadius: 0,
        overflow: 'visible',
    },
    arrows: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'rgba(255, 255, 255, 0.85) !important',
        border: 'none !important',
        cursor: 'pointer',
        zIndex: 2,
        fontSize: '22px !important',
        color: `${palette.text} !important`,
        borderRadius: '50% !important',
        padding: '0 !important',
        display: 'flex !important',
        justifyContent: 'center !important',
        alignItems: 'center !important',
        width: '40px !important',
        height: '40px !important',
        boxShadow: shadow.card,
    },
    leftArrow: {
        left: '16px'
    },
    rightArrow: {
        right: '16px'
    },
    thumbnail: {
        height: '100%',
        width: '100%',
        objectFit: 'cover',
        borderRadius: radius.sm,
    },
    imageSlide: {
        width: '100% !important',
        height: '100%',
        objectFit: 'cover',
        borderRadius: radius.lg,
    },
}));
